var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPopcorn = function SvgIconPopcorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.235a4.37 4.37 0 0 0-3.886 2.377 4.375 4.375 0 0 0-5.332 3.73 1.76 1.76 0 0 0-.467 1.624l.002.01 2.57 10.922v.005a1.76 1.76 0 0 0 1.695 1.347h10.837a1.76 1.76 0 0 0 1.694-1.347l.001-.005 2.57-10.922.001-.01a1.76 1.76 0 0 0-.468-1.625 4.374 4.374 0 0 0-5.33-3.73A4.37 4.37 0 0 0 12 1.236m7.085 5.769a2.377 2.377 0 0 0-3.325-1.227 1 1 0 0 1-1.447-.673 2.366 2.366 0 0 0-4.626 0 1 1 0 0 1-1.447.673 2.375 2.375 0 0 0-3.325 1.226l3.282.941 3.146-1.258a1.73 1.73 0 0 1 1.315 0l3.146 1.258zM17.212 19.25h-1.82l1.263-9.47 2.985-.855zm-3.838 0 1.282-9.61L12 8.576 9.344 9.639l1.282 9.61zM7.345 9.78 4.36 8.926 6.788 19.25h1.82z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPopcorn;